import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumericService {
  public checkMaxBusiness(maxCount: number, value: number): number {
    if (value <= maxCount) {
      return value;
    } else {
      return maxCount;
    }
  }

  private checkMinBusiness(minCount: number, value: number): number {
    if (value <= minCount) {
      return minCount;
    } else {
      return value;
    }
  }

  private checkMinAndMaxBusiness(
    minCount: number,
    maxCount: number,
    value: number
  ): number {
    const checkMax=this.checkMaxBusiness(maxCount,value);
    if (checkMax!=value) {
        return checkMax;
    }

    return this.checkMinBusiness(minCount,value);
  }

  public checkMax(maxCount: any, value: any): string {
    try {
      const maxCountNumber = parseInt(maxCount, 10);
      const valueNumber = parseInt(value, 10);
      const answer = this.checkMaxBusiness(maxCountNumber, valueNumber);
      return answer.toString();
    } catch (error) {
      return value.toString();
    }
  }

  public checkMin(minCount: any, value: any): string {
    try {
      const minCountNumber = parseInt(minCount, 10);
      const valueNumber = parseInt(value, 10);
      const answer = this.checkMinBusiness(minCountNumber, valueNumber);
      return answer.toString();
    } catch (error) {
      return value.toString();
    }
  }

  public checkMinAndMax(minCount: any,
    maxCount: any,
    value: any
  ): string {
    try {
        const maxCountNumber = parseInt(maxCount, 10);
        const minCountNumber = parseInt(minCount, 10);
        const valueNumber = parseInt(value, 10);
        const answer = this.checkMinAndMaxBusiness(minCountNumber,maxCountNumber, valueNumber);
        return answer.toString();
      } catch (error) {
        return value.toString();
      }
  }

  public checkMinAndMaxNumber(minCount: any,
    maxCount: any,
    value: any
  ): number {
    try {
        const maxCountNumber = parseInt(maxCount, 10);
        const minCountNumber = parseInt(minCount, 10);
        const valueNumber = parseInt(value, 10);
        const answer = this.checkMinAndMaxBusiness(minCountNumber,maxCountNumber, valueNumber);
        return answer;
      } catch (error) {
        return value;
      }
  }

  public checkNumber(value:string | undefined){
    if (value==null|| value==undefined) {
      return value;
    }
    let result= value.replace(/[^\d]/g, '');
    result= result.replace(/^0{1,}/g, '');

    return result;
  }

  public checkJustWord(value:string | undefined){
    if (value==null|| value==undefined) {
      return value;
    }
    return value.replace(/[^آ-یa-zA-Z ]/g, '');
  }

  public roundPrice(input:number):number{
    let result=input;
    const inputThousand=input / 1000;
    if (input<1000) {
      return result;
    }
    
    if(input%1000==0){
      return result;
    }

    if(input%1000>=500){
      result = Math.ceil(inputThousand) * 1000;
    }else{
      result = Math.floor(inputThousand) * 1000;
    }

    return result;
  }
}
